import React, { Fragment } from "react";
import { Link } from "react-router-dom/cjs/react-router-dom.min";

import GreenLogo from "../layout/Innovators/GreenLogo";
import IMEAltLogo from "../layout/IME/IMEAltLogo";

const Agreement = () => {
  return (
    <Fragment>
      <nav className="login-nav background-dark-black border-bottom grey">
        <div className="action-items-index">
          <Link to="/">
            <div className="action-button-index green">
              <i className="fas fa-angle-left action-icon-index-alt green fa-lg"></i>
            </div>
          </Link>
          <p className="action-text-index green">Back</p>
        </div>
        <Link to="/">
          <div className="center-nav">
            <div className="index-logo-alt">
              <GreenLogo />
            </div>
            <i className="fas fa-trademark green fa-sm mt-10"></i>
            <div className="index-logo">
              <IMEAltLogo />
            </div>
          </div>
        </Link>
      </nav>
      <div className="flex-all-content-fixed-agreement">
        <div className="agreement-guidelines-container">
          <div className="flex-center">
            <p className="agreement-title green">
              Terms of Agreement and Community Guidelines
            </p>
          </div>
          <div className="agreement-grid">
            <div>
              <div className="table-of-contents">
                <div className="flex-center">
                  <p className="agreement-title green">Table of Contents</p>
                </div>
                <div className="contents-list">
                  <div className="contents-list-container">
                    <ul>
                      <li className="contents-list-item green bold">
                        1. Dress Code Policy
                      </li>
                      <li className="contents-list-item green bold">
                        2. Account Security
                      </li>
                      <li className="contents-list-item green bold">
                        3. Age Restrictions
                      </li>
                      <li className="contents-list-item green bold">
                        4. Community Posts
                      </li>
                      <li className="contents-list-item green bold">
                        5. Constructive Feedback
                      </li>
                      <li className="contents-list-item green bold">
                        6. Content Moderation
                      </li>
                      <li className="contents-list-item green bold">
                        7. Content Posting
                      </li>
                      <li className="contents-list-item green bold">
                        8. Direct Messaging
                      </li>
                      <li className="contents-list-item green bold">
                        9. Intellectual Property
                      </li>
                      <li className="contents-list-item green bold">
                        10. Language
                      </li>
                      <li className="contents-list-item green bold">
                        11. Live Chat Conduct
                      </li>
                      <li className="contents-list-item green bold">
                        12. Live Streaming Conduct
                      </li>
                      <li className="contents-list-item green bold">
                        13. Multiple Accounts
                      </li>
                      <li className="contents-list-item green bold">
                        14. Privacy
                      </li>
                      <li className="contents-list-item green bold">
                        15. Reporting Issues
                      </li>
                      <li className="contents-list-item green bold">
                        16. Respectful Communication
                      </li>
                      <li className="contents-list-item green bold">
                        17. Safety
                      </li>
                      <li className="contents-list-item green bold">
                        18. Third-Party Software and Applications
                      </li>
                      <li className="contents-list-item green bold">
                        19. Zero Tolerance for Discrimination
                      </li>
                      <li className="contents-list-item green bold">
                        20. Moderators
                      </li>
                      <li className="contents-list-item green bold">
                        21. Acceptance of Terms
                      </li>
                      <li className="contents-list-item green bold">
                        22. Account Termination
                      </li>
                      <li className="contents-list-item green bold">
                        23. Availability of Features
                      </li>
                      <li className="contents-list-item green bold">
                        24. Changes to Terms
                      </li>
                      <li className="contents-list-item green bold">
                        25. Compliance with Laws
                      </li>
                      <li className="contents-list-item green bold">
                        26. Content Ownership
                      </li>
                      <li className="contents-list-item green bold">
                        27. Data Usage
                      </li>
                      <li className="contents-list-item green bold">
                        28. Disclaimer of Warranties
                      </li>
                      <li className="contents-list-item green bold">
                        29. Dispute Resolution
                      </li>
                      <li className="contents-list-item green bold">
                        30. Employer Subscriptions
                      </li>
                      <li className="contents-list-item green bold">
                        31. Entire Agreement
                      </li>
                      <li className="contents-list-item green bold">
                        32. Governing Law
                      </li>
                      <li className="contents-list-item green bold">
                        33. ime Articles
                      </li>
                      <li className="contents-list-item green bold">
                        34. Indemnification
                      </li>
                      <li className="contents-list-item green bold">
                        35. Individual Responsibility
                      </li>
                      <li className="contents-list-item green bold">
                        36. Intellectual Property Rights
                      </li>
                      <li className="contents-list-item green bold">
                        37. Limitation of Liability
                      </li>
                      <li className="contents-list-item green bold">
                        38. Location
                      </li>
                      <li className="contents-list-item green bold">
                        39. Mentor Courses
                      </li>
                      <li className="contents-list-item green bold">
                        40. No Warranty
                      </li>
                      <li className="contents-list-item green bold">
                        41. Payments and Donations
                      </li>
                      <li className="contents-list-item green bold">
                        42. Privacy Policy
                      </li>
                      <li className="contents-list-item green bold">
                        43. Protection of Founder
                      </li>
                      <li className="contents-list-item green bold">
                        44. Refund Policy
                      </li>
                      <li className="contents-list-item green bold">
                        45. Severability
                      </li>
                      <li className="contents-list-item green bold">
                        46. Site Termination
                      </li>
                      <li className="contents-list-item green bold">
                        47. Third-Party Links
                      </li>
                      <li className="contents-list-item green bold">
                        48. Third-Party Software and Applications
                      </li>
                      <li className="contents-list-item green bold">
                        49. User Responsibilities
                      </li>
                      <li className="contents-list-item green bold">
                        50. User Types
                      </li>
                      <li className="contents-list-item green bold">
                        51. Waiver
                      </li>
                      <li className="contents-list-item green bold">
                        52. AI Policy Agreement
                      </li>
                      <li className="contents-list-item green bold">
                        53. Username Change Policy
                      </li>
                      <li className="contents-list-item green bold">
                        54. Self-Promotion Policy
                      </li>
                      <li className="contents-list-item green bold">
                        55. Sexual Content/Nudity
                      </li>
                      <li className="contents-list-item green bold">
                        56. Copyright Claims Policy
                      </li>
                      <li className="contents-list-item green bold">
                        57. Discord Usage Agreement
                      </li>
                      <li className="contents-list-item green bold">
                        58. User Ban and Timeout Agreement
                      </li>
                      <li className="contents-list-item green bold">
                        59. Content Redistribution Agreement
                      </li>
                      <li className="contents-list-item green bold">
                        60. Agreement on Reporting Conduct
                      </li>
                      <li className="contents-list-item green bold">
                        61. Conflict of Interest Agreement
                      </li>
                      <li className="contents-list-item green bold">
                        62. Substance-Free Participation Agreement
                      </li>
                      <li className="contents-list-item green bold">
                        63. Recording and Content Use Agreement
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <div className="flex-center">
                <p className="agreement-title green">
                  Guidelines and Agreements
                </p>
              </div>
              <div className="guidelines-agreements white">
                <p className="tos-title green bold">1. Dress Code Policy</p>
                <p className="white">
                  Purpose:
                  <br /> This policy aims to ensure a professional, respectful,
                  and consistent appearance for all users when participating in
                  on-camera activities on the platform.
                  <br />
                  <br /> 1. Requirement for Appropriate Appearance
                  <br /> All users are required to adhere to a standard of dress
                  that is suitable for the context and purpose of their
                  on-camera participation. This includes, but is not limited to:
                  <br /> Wearing clean, presentable clothing that avoids
                  offensive language, images, or symbols.
                  <br />
                  Ensuring attire reflects a level of professionalism
                  appropriate to the nature of the interaction (e.g., meetings,
                  live streams, or recorded content).
                  <br /> Avoiding excessively casual or revealing clothing that
                  may be deemed inappropriate or disruptive.
                  <br />
                  <br /> 2. Applicability
                  <br /> This policy applies to all users utilizing the
                  platform’s on-camera features, including live video sessions,
                  recorded content, and any other form of visual interaction.
                  <br />
                  <br /> 3. Consequences of Non-Compliance
                  <br /> Users who fail to comply with the dress code may face
                  the following actions: Warning or notification to adjust their
                  appearance. Restriction from participating in on-camera
                  activities until the issue is resolved. Permanent suspension
                  or account termination for repeated violations or egregious
                  breaches of the policy.
                  <br />
                  <br /> 4. Respect for Cultural and Personal Expression
                  <br /> While the policy requires appropriate attire, the
                  platform values diversity and respects cultural and personal
                  expressions. Users are encouraged to wear clothing that aligns
                  with their identity and beliefs, provided it adheres to the
                  guidelines outlined in this policy.
                  <br />
                  <br /> 5. Acknowledgment
                  <br /> By engaging in on-camera activities, users acknowledge
                  their understanding of and agreement to abide by this policy.
                  <br />
                  <br /> 6. Policy Updates
                  <br /> ime reserves the right to update this policy as
                  necessary to maintain a professional and respectful
                  environment.
                </p>
              </div>
              <div className="guidelines-agreements white">
                <p className="tos-title green bold">2. Account Security</p>
                <p className="white">
                  Users are responsible for maintaining the security of their
                  accounts. Sharing login credentials is prohibited.
                </p>
              </div>
              <div className="guidelines-agreements white">
                <p className="tos-title green bold">3. Age Restrictions</p>
                <p className="white">
                  Users must be at least 13 years old to join the community.
                  Parental consent is required for users under 18.
                </p>
              </div>
              <div className="guidelines-agreements white">
                <p className="tos-title green bold">4. Community Posts</p>
                <p className="white">
                  Users can create posts in the "Community Posts" page using
                  text, images, or videos. All content must align with the
                  community guidelines and terms of agreement policies.
                </p>
              </div>
              <div className="guidelines-agreements white">
                <p className="tos-title green bold">5. Constructive Feedback</p>
                <p className="white">
                  Provide feedback that is constructive and aimed at helping
                  others improve. Personal attacks or negative comments are not
                  allowed.
                </p>
              </div>
              <div className="guidelines-agreements white">
                <p className="tos-title green bold">6. Content Moderation</p>
                <p className="white">
                  All content is subject to review by moderators. Content that
                  violates guidelines may be removed without notice.
                </p>
              </div>
              <div className="guidelines-agreements white">
                <p className="tos-title green bold">7. Content Posting</p>
                <p className="white">
                  Ensure that all content posted is relevant to the community
                  and adheres to our content guidelines. Spam, advertising, or
                  self-promotion without permission is not permitted.
                </p>
              </div>
              <div className="guidelines-agreements white">
                <p className="tos-title green bold">8. Direct Messaging</p>
                <p className="white">
                  Users can directly message other users on the site, based on
                  the other user's settings. All messages must comply with
                  community guidelines and terms of agreements. These messages
                  are not private and can be used for legal or informational
                  purposes, among others.
                </p>
              </div>
              <div className="guidelines-agreements white">
                <p className="tos-title green bold">9. Intellectual Property</p>
                <p className="white">
                  Respect intellectual property rights. Do not share content
                  that you do not have the right to distribute.
                </p>
              </div>
              <div className="guidelines-agreements white">
                <p className="tos-title green bold">10. Language</p>
                <p className="white">
                  Use of offensive language is prohibited. All communication
                  should be respectful and considerate.
                </p>
              </div>
              <div className="guidelines-agreements white">
                <p className="tos-title green bold">11. Live Chat Conduct</p>
                <p className="white">
                  Use live chat to communicate respectfully with other users and
                  during live streams. Inappropriate behavior, harassment, or
                  spamming in live chat will not be tolerated.
                </p>
              </div>
              <div className="guidelines-agreements white">
                <p className="tos-title green bold">
                  12. Live Streaming Conduct
                </p>
                <p className="white">
                  All live streaming content must adhere to these guidelines.
                  Inappropriate content, including but not limited to violence,
                  explicit material, and illegal activities, is strictly
                  prohibited.
                </p>
              </div>
              <div className="guidelines-agreements white">
                <p className="tos-title green bold">13. Multiple Accounts</p>
                <p className="white">
                  Creating multiple accounts to bypass restrictions or bans is
                  not allowed.
                </p>
              </div>
              <div className="guidelines-agreements white">
                <p className="tos-title green bold">14. Privacy</p>
                <p className="white">
                  Respect the privacy of others. Do not share personal
                  information without explicit consent.
                </p>
              </div>
              <div className="guidelines-agreements white">
                <p className="tos-title green bold">15. Reporting Issues</p>
                <p className="white">
                  Report any issues or violations of these guidelines to the
                  site administrators.
                </p>
              </div>
              <div className="guidelines-agreements white">
                <p className="tos-title green bold">
                  16. Respectful Communication
                </p>
                <p className="white">
                  All members must communicate with respect and courtesy.
                  Harassment, discrimination, and hate speech are strictly
                  prohibited.
                </p>
              </div>
              <div className="guidelines-agreements white">
                <p className="tos-title green bold">17. Safety</p>
                <p className="white">
                  Do not engage in or promote any illegal activities. Ensure
                  that all interactions are safe and legal.
                </p>
              </div>
              <div className="guidelines-agreements white">
                <p className="tos-title green bold">
                  18. Third-Party Software and Applications
                </p>
                <p className="white">
                  The use of third-party software and applications that interact
                  with ime must comply with all community guidelines and terms
                  of agreement. Unauthorized or harmful software is prohibited.
                </p>
              </div>
              <div className="guidelines-agreements white">
                <p className="tos-title green bold">
                  19. Zero Tolerance for Discrimination
                </p>
                <p className="white">
                  Plagiarism, homophobia, racism, and other discriminatory
                  content or actions are strictly prohibited.
                </p>
              </div>
              <div className="guidelines-agreements white">
                <p className="tos-title green bold">20. Moderators</p>
                <p className="white">
                  As a moderator on this site, you acknowledge and agree that
                  your role is entirely voluntary and unpaid. Moderators
                  contribute their time and efforts to ensure a positive and
                  respectful environment for all users. This role does not
                  constitute employment or any contractual relationship with the
                  site. Furthermore, the site administration reserves the right
                  to terminate your position as a moderator at any time, for any
                  reason, without prior notice. By accepting this role, you
                  agree to these terms and understand that your position is
                  subject to change at the discretion of the site
                  administration.
                </p>
              </div>
              <div className="guidelines-agreements white">
                <p className="tos-title green bold">21. Acceptance of Terms</p>
                <p className="white">
                  By accessing and using ime, you agree to comply with these
                  terms and any applicable laws and regulations. Any breach of
                  this agreement will result in loss of site benefits and
                  potential account ban at the discretion of site
                  administration.
                </p>
              </div>
              <div className="guidelines-agreements white">
                <p className="tos-title green bold">22. Account Termination</p>
                <p className="white">
                  ime reserves the right to terminate accounts that violate the
                  terms of agreement or community guidelines.
                </p>
              </div>
              <div className="guidelines-agreements white">
                <p className="tos-title green bold">
                  23. Availability of Features
                </p>
                <p className="white">
                  All features of the site may not be available at all times.
                  ime reserves the right to modify, suspend, or discontinue any
                  feature or service at any time without notice.
                </p>
              </div>
              <div className="guidelines-agreements white">
                <p className="tos-title green bold">24. Changes to Terms</p>
                <p className="white">
                  ime may update these terms from time to time. You will be
                  notified of any significant changes, and your continued use of
                  the site constitutes acceptance of the updated terms.
                </p>
              </div>
              <div className="guidelines-agreements white">
                <p className="tos-title green bold">25. Compliance with Laws</p>
                <p className="white">
                  Users must comply with all applicable local, state, national,
                  and international laws and regulations while using ime.
                </p>
              </div>
              <div className="guidelines-agreements white">
                <p className="tos-title green bold">26. Content Ownership</p>
                <p className="white">
                  You retain ownership of the content you post, but you grant
                  ime a non-exclusive, royalty-free license to use, display, and
                  distribute your content.
                </p>
              </div>
              <div className="guidelines-agreements white">
                <p className="tos-title green bold">27. Data Usage</p>
                <p className="white">
                  By using ime, you consent to the collection and use of your
                  data.
                </p>
              </div>
              <div className="guidelines-agreements white">
                <p className="tos-title green bold">
                  28. Disclaimer of Warranties
                </p>
                <p className="white">
                  ime is provided "as is" without any warranties, express or
                  implied. The founder does not guarantee the accuracy,
                  reliability, or availability of the site.
                </p>
              </div>
              <div className="guidelines-agreements white">
                <p className="tos-title green bold">29. Dispute Resolution</p>
                <p className="white">
                  Any disputes arising from the use of ime will be resolved
                  through arbitration in Colorado, USA.
                </p>
              </div>
              <div className="guidelines-agreements white">
                <p className="tos-title green bold">
                  30. Employer Subscriptions
                </p>
                <p className="white">
                  Employers have subscription tiers on the site that they must
                  be actively subscribed to in order to use the site. Once
                  actively subscribed, employers can post career opportunities,
                  live stream, and interact with innovators based on the plan
                  they are actively subscribed to.
                </p>
              </div>
              <div className="guidelines-agreements white">
                <p className="tos-title green bold">31. Entire Agreement</p>
                <p className="white">
                  These terms constitute the entire agreement between you and
                  ime regarding the use of the site and supersede any prior
                  agreements or understandings, whether written or oral.
                </p>
              </div>
              <div className="guidelines-agreements white">
                <p className="tos-title green bold">32. Governing Law</p>
                <p className="white">
                  These terms are governed by the laws of the state of Colorado,
                  United States. Any legal disputes will be resolved in the
                  courts of Colorado, USA.
                </p>
              </div>
              <div className="guidelines-agreements white">
                <p className="tos-title green bold">33. ime Articles</p>
                <p className="white">
                  ime Articles are published on behalf of the site. These
                  articles are not professionally certified.
                </p>
              </div>
              <div className="guidelines-agreements white">
                <p className="tos-title green bold">34. Indemnification</p>
                <p className="white">
                  You agree to indemnify and hold harmless ime and its founder
                  from any claims, damages, or expenses arising from your use of
                  the site or violation of these terms.
                </p>
              </div>
              <div className="guidelines-agreements white">
                <p className="tos-title green bold">
                  35. Individual Responsibility
                </p>
                <p className="white">
                  Thoughts, opinions, and actions are all solely individually
                  based. ime is not responsible for the actions or content
                  posted by its users.
                </p>
              </div>
              <div className="guidelines-agreements white">
                <p className="tos-title green bold">
                  36. Intellectual Property Rights
                </p>
                <p className="white">
                  Users must respect the intellectual property rights of others.
                  Unauthorized use of copyrighted material is prohibited.
                </p>
              </div>
              <div className="guidelines-agreements white">
                <p className="tos-title green bold">
                  37. Limitation of Liability
                </p>
                <p className="white">
                  ime is not liable for any damages or losses resulting from
                  your use of the site. You use ime at your own risk.
                </p>
              </div>
              <div className="guidelines-agreements white">
                <p className="tos-title green bold">38. Location</p>
                <p className="white">
                  Although ime operates online, its physical and legal location
                  is in the state of Colorado, United States.
                </p>
              </div>
              <div className="guidelines-agreements white">
                <p className="tos-title green bold">39. Mentor Courses</p>
                <p className="white">
                  Courses created by mentors on ime are not professionally
                  certified and are intended for informational and educational
                  purposes only. Mentors must have one active and approved
                  course on the site at all times. Streaming for mentors is not
                  permitted if this agreement is not met. Mentors do not receive
                  revenue for their initial course on the site. As a benefit to
                  users that are actively subscribed to said mentor, they have
                  access to their first course on the site.
                </p>
              </div>
              <div className="guidelines-agreements white">
                <p className="tos-title green bold">40. No Warranty</p>
                <p className="white">
                  ime makes no warranties or representations about the accuracy
                  or completeness of the site's content or the content of any
                  sites linked to ime.
                </p>
              </div>
              <div className="guidelines-agreements white">
                <p className="tos-title green bold">
                  41. Payments and Donations
                </p>
                <p className="white">
                  ime accepts payments for subscriptions and donations. By
                  making a payment or donation, you agree to these terms and
                  conditions. All transactions are final and non-refundable
                  unless otherwise stated. ime uses third-party software to
                  accept payments. Donations accumulate based on an email being
                  an exact match to the prior email used for any previous
                  donations. Please only donate in support of the site in its
                  current availability. ime also asks that you do not donate if
                  these User Agreements and Community Guidelines are not able to
                  be adhere to by the donating user account.
                </p>
              </div>
              <div className="guidelines-agreements white">
                <p className="tos-title green bold">42. Privacy Policy</p>
                <p className="white">
                  Your use of ime is subject to our privacy policy, which
                  outlines how we collect, use, and protect your personal
                  information.
                </p>
              </div>
              <div className="guidelines-agreements white">
                <p className="tos-title green bold">
                  43. Protection of Founder
                </p>
                <p className="white">
                  As the sole founder, developer, and operator of "ime," you are
                  protected from any legal claims or lawsuits arising from the
                  use of the site. Users agree to waive any right to sue the
                  founder personally for any issues related to the site.
                </p>
              </div>
              <div className="guidelines-agreements white">
                <p className="tos-title green bold">44. Refund Policy</p>
                <p className="white">
                  Subscription fees and donations are non-refundable, except as
                  required by law.
                </p>
              </div>
              <div className="guidelines-agreements white">
                <p className="tos-title green bold">45. Severability</p>
                <p className="white">
                  If any provision of these terms is found to be invalid or
                  unenforceable, the remaining provisions will continue to be
                  valid and enforceable.
                </p>
              </div>
              <div className="guidelines-agreements white">
                <p className="tos-title green bold">46. Site Termination</p>
                <p className="white">
                  ime reserves the right to terminate the site at any time for
                  any reason. All active and/or pending subscriptions,
                  transactions, and content are non-refundable and
                  non-redistributable.
                </p>
              </div>
              <div className="guidelines-agreements white">
                <p className="tos-title green bold">47. Third-Party Links</p>
                <p className="white">
                  ime may contain links to third-party websites. ime is not
                  responsible for the content or practices of these websites.
                </p>
              </div>
              <div className="guidelines-agreements white">
                <p className="tos-title green bold">
                  48. Third-Party Software and Applications
                </p>
                <p className="white">
                  The use of third-party software and applications that interact
                  with ime must comply with all terms of agreement. Unauthorized
                  or harmful software is prohibited.
                </p>
              </div>
              <div className="guidelines-agreements white">
                <p className="tos-title green bold">
                  49. User Responsibilities
                </p>
                <p className="white">
                  You are responsible for your actions and the content you post
                  on ime. You agree not to engage in any activity that could
                  harm the site or its members.
                </p>
              </div>
              <div className="guidelines-agreements white">
                <p className="tos-title green bold">50. User Types</p>
                <p className="white">
                  ime consists of three user types: Mentors, Innovators, and
                  Employers. Each user type is expected to adhere to these
                  guidelines and terms of agreement.
                </p>
              </div>
              <div className="guidelines-agreements white">
                <p className="tos-title green bold">51. Waiver</p>
                <p className="white">
                  By using ime, you acknowledge and agree to the following:
                  <br />
                  <br />
                  Assumption of Risk: You understand and accept the risks
                  associated with using an online platform, including but not
                  limited to data breaches, unauthorized access, and technical
                  issues.
                  <br />
                  <br /> Limitation of Liability: ime and its founder are not
                  liable for any damages or losses resulting from your use of
                  the site. You use ime at your own risk. No Warranty: ime is
                  provided "as is" without any warranties, express or implied.
                  The founder does not guarantee the accuracy, reliability, or
                  availability of the site. Release of Claims: You release ime
                  and its founder from any claims
                </p>
              </div>
              <div className="guidelines-agreements white">
                <p className="tos-title green bold">52. AI Policy Agreement</p>
                <p className="white">
                  By using this website, users acknowledge and agree that
                  artificial intelligence (AI) tools, bots, or applications are
                  not permitted on the site unless explicitly authorized by ime.
                  This policy is implemented to ensure the integrity, security,
                  and quality of user interactions and content on our platform.
                  <br />
                  <br />
                  The prohibition of AI tools stems from our ongoing
                  understanding and evaluation of AI technologies, their
                  potential impacts, and the need to maintain a safe and
                  respectful environment for all users. Unauthorized use of AI
                  may lead to inaccuracies, misinformation, or disruptions
                  within the community, which we strive to avoid.
                  <br />
                  <br /> ime reserves the right to review and grant permission
                  for specific AI usage on a case-by-case basis. Users found
                  utilizing AI tools without explicit authorization from ime may
                  face account suspension or termination. For inquiries about AI
                  usage permissions, please contact ime at
                  <span className="green bold mx-5">
                    ime.live.mail@gmail.com.
                  </span>
                  <br />
                  <br /> By continuing to use the website, users agree to adhere
                  to this AI Policy Agreement and understand that any violations
                  may result in consequences as outlined above.
                </p>
              </div>
              <div className="guidelines-agreements white">
                <p className="tos-title green bold">
                  53. Username Change Policy
                </p>
                <p className="white">
                  Users are permitted to change their usernames a maximum of
                  three times per account. Each username change utilizes a "name
                  token," and every account is allocated three name tokens upon
                  creation.
                  <br />
                  <br /> To ensure the continuity and integrity of user
                  identities within our community, the following guidelines
                  apply to username changes:
                  <br />
                  <br /> 1. Each account is limited to a total of three name
                  tokens, which can be used to change the username up to three
                  times.
                  <br /> 2. Once all three name tokens have been used, no
                  further username changes will be allowed for that account.
                  <br /> 3. Users should carefully consider their new usernames
                  before confirming changes, as tokens are non-refundable and
                  cannot be replenished.
                  <br />
                  <br /> By continuing to use this website, users agree to
                  adhere to this Username Change Policy. Any abuse or misuse of
                  the username change feature may result in account suspension
                  or termination. If you have any questions or require
                  assistance, please contact our support team.
                </p>
              </div>
              <div className="guidelines-agreements white">
                <p className="tos-title green bold">
                  54. Self-Promotion Policy
                </p>
                <p className="white">
                  To maintain a focused and respectful environment for all
                  users, this website strictly prohibits self-promotion in any
                  form. This policy is put in place to prevent spam, maintain
                  the quality of interactions, and ensure that the community
                  remains a valuable resource for everyone.
                  <br />
                  <br /> The following guidelines apply to self-promotion:
                  <br />
                  <br /> 1. Users may not use posts, comments, profiles, chat or
                  any other part of the site to promote their own products,
                  services, social media accounts, or any other personal
                  interests.
                  <br /> 2. Self-promotional content includes, but is not
                  limited to, advertisements, links to external sites for
                  personal gain, solicitations for followers or subscribers, and
                  posts that primarily serve to promote oneself rather than
                  contribute to the community.
                  <br /> 3. Any user found violating this policy may have their
                  content removed and face account suspension or termination.
                  <br />
                  <br /> By continuing to use this website, users agree to
                  adhere to this Self-Promotion Policy.
                </p>
              </div>
              <div className="guidelines-agreements white">
                <p className="tos-title green bold">
                  55. Sexual Content/Nudity
                </p>
                <p className="white">
                  To maintain a respectful, safe, and welcoming environment for
                  all users, this website strictly prohibits any content
                  containing sexual material or nudity. The following guidelines
                  apply to ensure compliance with this policy:
                  <br />
                  <br /> 1. Users may not post, share, or distribute any content
                  that includes explicit sexual material, nudity, or any other
                  inappropriate content of a sexual nature.
                  <br /> 2. This prohibition extends to images, videos, text,
                  links, and any other media or forms of communication on the
                  site.
                  <br /> 3. Content that implies, suggests, or promotes sexual
                  acts or nudity is also strictly forbidden. Any user found in
                  violation of this policy will have their content removed and
                  may face account suspension or termination.
                  <br />
                  <br /> By continuing to use this website, users agree to
                  adhere to this Prohibited Content Agreement. If you have any
                  questions or need further clarification, please contact our
                  support team.
                </p>
              </div>
              <div className="guidelines-agreements white">
                <p className="tos-title green bold">
                  56. Copyright Claims Policy
                </p>
                <p className="white">
                  At ime, we respect the intellectual property rights of others
                  and strive to comply with all relevant laws. If you believe
                  that your copyrighted work has been used in a way that
                  constitutes copyright infringement, please notify us in
                  writing as outlined below.
                  <br />
                  <br /> How to Submit a Copyright Claim
                  <br />
                  <br />
                  If you believe your copyrighted material has been used without
                  proper authorization, you may submit a written copyright claim
                  to us via email. Please include the following information in
                  your claim:
                  <br />
                  <br /> 1. Identification of the copyrighted work that you
                  believe has been infringed, or if multiple works are covered
                  by a single notification, a representative list of such works.
                  <br />
                  2. Identification of the material that you believe is
                  infringing and where it is located on our website or platform.
                  Please provide sufficient detail to allow us to locate the
                  material.
                  <br /> 3. Your contact information, including your name,
                  address, telephone number, and email address.
                  <br /> 4. A statement that you have a good faith belief that
                  the use of the material in the manner complained of is not
                  authorized by the copyright owner, its agent, or the law.
                  <br /> 5. A statement that the information in the notification
                  is accurate, and under penalty of perjury, that you are
                  authorized to act on behalf of the copyright owner.
                  <br /> 6. An electronic or physical signature of the person
                  authorized to act on behalf of the owner of the copyright
                  interest.
                  <br />
                  <br /> Please send your copyright claim to the following email
                  address:{" "}
                  <span className="green bold mx-5">
                    ime.live.mail@gmail.com.
                  </span>{" "}
                  <br />
                  <br /> Response Time
                  <br />
                  <br /> We will respond to valid copyright claims within at
                  least 10 business days. Please note that it may take
                  additional time to investigate and address your claim,
                  depending on the complexity of the issue.
                  <br />
                  <br />
                  Counter-Notification Procedure
                  <br />
                  <br /> If you believe that your content was removed or
                  disabled by mistake or misidentification, you may file a
                  counter-notification with us. To be effective, the
                  counter-notification must be in writing and include the
                  following:
                  <br />
                  <br /> 1. Identification of the material that has been removed
                  or to which access has been disabled and the location at which
                  the material appeared before it was removed or access to it
                  was disabled.
                  <br /> 2. A statement under penalty of perjury that you have a
                  good faith belief that the material was removed or disabled as
                  a result of mistake or misidentification.
                  <br /> 3. Your contact information, including your name,
                  address, telephone number, and email address.
                  <br /> 4. A statement that you consent to the jurisdiction of
                  the federal district court in your location, or if your
                  address is outside the United States, for any judicial
                  district in which we may be found, and that you will accept
                  service of process from the person who provided the original
                  notification of the alleged infringement.
                  <br /> 5. An electronic or physical signature of the person
                  authorized to act on behalf of the owner of the content.
                  <br />
                  <br /> Changes to This Policy
                  <br />
                  <br /> We reserve the right to update or modify this policy at
                  any time without prior notice. Any changes will be effective
                  immediately upon posting the revised policy on our website.
                </p>
              </div>
              <div className="guidelines-agreements white">
                <p className="tos-title green bold">
                  57. Discord Usage Agreement
                </p>
                <p className="white">
                  By using our website and accessing our Discord server, you
                  agree to comply with both Discord's policies and community
                  guidelines as well as ime's terms and conditions outlined in
                  this agreement.
                  <br />
                  <br /> Acceptance of Terms
                  <br />
                  <br /> By joining and participating in our Discord Server, you
                  agree to adhere to:
                  <br />
                  <br /> 1. Discord's Terms of Service and Community Guidelines
                  <br />
                  <br /> - Discord Terms of Service
                  <br />- Discord Community Guidelines
                  <br />
                  <br /> 2. ime's Policies and Guidelines
                  <br />
                  <br /> General Conduct
                  <br />
                  <br /> While participating in our Server, you must:
                  <br />
                  <br /> 1. Respect All Users: Treat everyone with respect and
                  refrain from any form of harassment, discrimination, or hate
                  speech.
                  <br /> 2. Follow Content Guidelines: Do not share or post
                  inappropriate, explicit, or offensive content.
                  <br /> 3. Maintain Privacy: Do not share personal information
                  of yourself or others without consent.
                  <br /> 4. Adhere to Moderation: Follow the instructions of
                  Server moderators and admins. Failure to comply may result in
                  temporary or permanent suspension from the Server.
                  <br /> <br /> Usage of Server Resources
                  <br />
                  <br /> 1. Channels and Topics: Use the designated channels for
                  relevant discussions. Keep off-topic conversations to
                  appropriate channels.
                  <br /> 2. Content Sharing: Share content responsibly and
                  ensure it aligns with both Discord's and ime's content
                  policies.
                  <br /> 3. Reporting Issues: Report any breaches of this
                  agreement to Server moderators or admins promptly.
                  <br />
                  <br /> Enforcement of Policies
                  <br />
                  <br /> Violations of this agreement may result in disciplinary
                  actions including warnings, temporary bans, or permanent
                  removal from the Server. We reserve the right to enforce this
                  agreement at our discretion.
                  <br />
                  <br /> Amendments to the Agreement
                  <br />
                  <br /> We may update or modify this agreement as necessary.
                  Any changes will be effective immediately upon posting the
                  revised agreement on our website. Continued use of our Server
                  constitutes acceptance of the revised terms.
                </p>
              </div>
              <div className="guidelines-agreements white">
                <p className="tos-title green bold">
                  58. User Ban and Timeout Agreement
                </p>
                <p className="white">
                  1. Overview <br /> This agreement outlines the policies and
                  procedures regarding the banning and timeout of users on our
                  site. These measures are taken to ensure a safe and respectful
                  environment for all community members.
                  <br />
                  <br /> 2. Submission of Un-Ban Requests <br /> All un-ban
                  requests must be submitted to:{" "}
                  <span className="green bold mx-5">
                    ime.live.mail@gmail.com.
                  </span>{" "}
                  Please include the username of the banned account, your first
                  and last name, and detailed information regarding the reason
                  for why you are requesting to be un-banned.
                  <br />
                  <br />
                  3. Violation of User Agreement or Community Guidelines
                  <br /> Users may be banned or placed on timeout for actions
                  including, but not limited to: Harassment or bullying of other
                  users Posting offensive or inappropriate content Spamming or
                  unwanted solicitation Breach of privacy or confidentiality Any
                  other behavior deemed harmful or disruptive to the community.
                  All rights for the banned user to interact with the site will
                  be waived.
                  <br />
                  <br /> 4. Duration of Timeouts
                  <br /> Timeouts are temporary suspensions designed to give
                  users a chance to reflect on their behavior. The duration of a
                  timeout will be determined based on the severity of the
                  violation.
                  <br />
                  <br /> 5. Enforcement
                  <br /> The enforcement of bans and timeouts is at the sole
                  discretion of the site administrators. Our decision is final
                  and binding.
                  <br />
                  <br /> 6. Updates to this Agreement
                  <br /> We reserve the right to update this agreement at any
                  time. Any changes will be communicated to the users through
                  appropriate channels.
                </p>
              </div>
              <div className="guidelines-agreements white">
                <p className="tos-title green bold">
                  59. Content Redistribution Agreement
                </p>
                <p className="white">
                  1. Introduction
                  <br /> This agreement establishes the terms regarding the use
                  and redistribution of content provided by ime. By accessing
                  our content, you agree to comply with the terms outlined in
                  this agreement.
                  <br />
                  <br /> 2. Ownership of Content
                  <br /> All content, including but not limited to text, images,
                  videos, audio, and graphics, is the exclusive property of ime
                  unless otherwise stated. This content is protected under
                  applicable copyright laws and international treaties.
                  <br />
                  <br /> 3. Prohibition of Redistribution
                  <br /> Users are strictly prohibited from redistributing,
                  reproducing, or sharing our content in any form or by any
                  means, including electronic, mechanical, photocopying,
                  recording, or other methods, without prior written permission
                  from ime.
                  <br />
                  <br /> 4. Permissible Use
                  <br /> Content provided by ime is for personal and
                  non-commercial use only. Redistribution or use of our content
                  for commercial purposes without explicit authorization is a
                  violation of this agreement.
                  <br /> <br /> 5. Requests for Permission
                  <br /> To request permission for redistribution, users must
                  contact ime at{" "}
                  <span className="green bold mx-5">
                    ime.live.mail@gmail.com.
                  </span>{" "}
                  All requests will be evaluated on a case-by-case basis, and
                  permission may be granted at the sole discretion of ime.
                  <br />
                  <br /> 6. Enforcement
                  <br /> Any violation of this agreement will be subject to
                  appropriate legal action, including but not limited to
                  penalties, fines, or other remedies as allowed by law.
                  <br />
                  <br /> 7. Modifications to this Agreement
                  <br /> ime reserves the right to amend or update this
                  agreement at any time. Users will be notified of any changes
                  through appropriate communication channels.
                </p>
              </div>
              <div className="guidelines-agreements white">
                <p className="tos-title green bold">
                  60. Agreement on Reporting Conduct
                </p>
                <p className="white">
                  Purpose:
                  <br /> This agreement outlines the terms and conditions
                  regarding the submission of reports within our platform to
                  ensure responsible and ethical use.
                  <br />
                  <br /> 1. Prohibition of False or Spam Reporting
                  <br /> All users are strictly prohibited from submitting
                  false, misleading, or spam reports. A false or spam report is
                  defined as any report deliberately submitted with inaccurate,
                  deceptive, or irrelevant information, or any report submitted
                  with the intent to harass, disrupt, or misuse the reporting
                  system.
                  <br />
                  <br /> 2. Consequences of Breach
                  <br /> A breach of this agreement, including but not limited
                  to the submission of false or spam reports, may result in
                  immediate and permanent termination of the user's account.
                  Additional actions may be taken at the discretion of the
                  platform, including restricting future access or further
                  investigation into misuse.
                  <br />
                  <br /> 3. Agreement to Terms
                  <br /> By using this platform, you acknowledge and agree to
                  abide by this policy. Your continued access and use of the
                  platform signify your consent to these terms.
                  <br /> <br /> 4. Reporting Mechanism Integrity
                  <br /> The integrity of our reporting mechanism is critical.
                  Users found in violation of this agreement may be subject to
                  review and disciplinary actions without prior warning.
                </p>
              </div>
              <div className="guidelines-agreements white">
                <p className="tos-title green bold">
                  61. Conflict of Interest Agreement
                </p>
                <p className="white">
                  Purpose:
                  <br /> This agreement establishes guidelines to ensure that
                  individuals maintain professional integrity and avoid
                  situations that may compromise or appear to compromise their
                  objectivity, loyalty, or decision-making due to personal or
                  external interests.
                  <br />
                  <br /> 1. Definition of Conflict of Interest
                  <br /> A conflict of interest arises when personal, financial,
                  or other external interests could interfere with, influence,
                  or appear to influence an individual's professional
                  responsibilities, obligations, or decision-making processes.
                  This includes, but is not limited to:
                  <br />
                  <br />
                  Personal financial gain or investment in competing
                  organizations.
                  <br /> Relationships (personal or familial) that could unduly
                  influence professional decisions.
                  <br /> Participation in activities or external roles that
                  conflict with organizational commitments.
                  <br />
                  <br /> 2. Disclosure Requirements
                  <br /> All individuals must disclose potential, perceived, or
                  actual conflicts of interest in a timely manner to the
                  appropriate authority or manager.
                  <br /> Disclosure should include relevant details to allow for
                  an informed assessment of the situation.
                  <br />
                  <br /> 3. Prohibited Actions
                  <br /> Individuals must not:
                  <br /> <br /> Use their position or access to confidential
                  information for personal gain.
                  <br /> Make decisions or recommendations that could unfairly
                  benefit themselves, family members, or associates.
                  <br /> Engage in activities or affiliations that directly
                  conflict with their professional duties without prior
                  approval.
                  <br />
                  <br /> 4. Resolution of Conflicts
                  <br />
                  Upon disclosure, ime will evaluate the conflict and determine
                  appropriate actions, which may include recusal, reassignment,
                  or other measures to mitigate the conflict.
                  <br />
                  Individuals must comply with all resolutions and guidance
                  provided.
                  <br />
                  <br />
                  5. Violations and Consequences
                  <br />
                  Failure to disclose a conflict of interest or engaging in
                  prohibited actions may result in disciplinary action, up to
                  and including permanent ban of user's account, as applicable.
                </p>
              </div>
              <div className="guidelines-agreements white">
                <p className="tos-title green bold">
                  62. Substance-Free Participation Agreement
                </p>
                <p className="white">
                  Purpose:
                  <br /> This agreement ensures that all users maintain a
                  professional and respectful environment by prohibiting the use
                  of drugs or alcohol while engaging in camera or audio-only
                  activities on the platform.
                  <br />
                  <br /> 1. Prohibition of Drugs and Alcohol
                  <br /> Users are strictly prohibited from using, being under
                  the influence of, or appearing to use drugs or alcohol while
                  participating in any camera or audio-only interactions on the
                  platform. This includes live video sessions, audio
                  discussions, and any other relevant activities.
                  <br />
                  <br /> 2. Expectations for Conduct
                  <br /> Users must present themselves in a manner that upholds
                  the integrity and professionalism of the platform.
                  <br /> Any behavior that suggests impairment or substance use
                  during on-camera or audio-only participation is strictly
                  forbidden.
                  <br />
                  <br /> 3. Consequences of Non-Compliance
                  <br /> Failure to comply with this agreement may result in the
                  following actions: Immediate removal from the activity or
                  session. Temporary suspension of account privileges. Permanent
                  account termination for repeated or egregious violations.
                  <br />
                  <br /> 4. Supportive Environment ime is committed to fostering
                  a safe and inclusive community. Users are encouraged to seek
                  support or assistance if they are facing challenges related to
                  substance use.
                  <br />
                  <br /> 5. Acknowledgment By using the platform’s camera or
                  audio-only features, users acknowledge and agree to adhere to
                  this policy. Non-compliance will be taken seriously to protect
                  the integrity of the community.
                </p>
              </div>
              <div className="guidelines-agreements white">
                <p className="tos-title green bold">
                  63. Recording and Content Use Agreement
                </p>
                <p className="white">
                  Purpose:
                  <br /> This agreement ensures transparency and outlines the
                  terms regarding the recording and use of content generated
                  during on-camera or audio-only activities on the platform.
                  <br />
                  <br /> 1. Recording of Activities By participating in any
                  on-camera or audio-only activities on the platform, users
                  acknowledge and consent to these activities being recorded.
                  This includes, but is not limited to:
                  <br /> Live video sessions
                  <br /> Audio discussions
                  <br /> Any other visual or auditory content generated during
                  platform interactions.
                  <br />
                  <br /> 2. Use of Recorded Content
                  <br /> ime reserves the right to utilize recorded content for
                  a variety of purposes, including but not limited to:
                  <br /> Quality assurance and training
                  <br /> Marketing and promotional materials
                  <br /> Research and development
                  <br /> Compliance with legal requirements Other legitimate
                  business needs.
                  <br />
                  <br /> 3. Privacy and Confidentiality
                  <br /> While the platform is committed to respecting user
                  privacy, participation in these activities constitutes consent
                  for the content to be used as outlined. Personally
                  identifiable information will be handled in accordance with
                  the platform’s privacy policy.
                  <br />
                  <br /> 4. User Responsibility
                  <br /> Users are encouraged to ensure their participation
                  aligns with this agreement and that they refrain from sharing
                  sensitive or private information during recorded sessions.
                  <br />
                  <br /> 5. Acknowledgment and Agreement
                  <br /> By participating in on-camera or audio-only activities,
                  users agree to the recording and use of their content as
                  described in this policy. Continued use of the platform
                  signifies understanding and acceptance of these terms.
                  <br />
                  <br /> 6. Policy Updates
                  <br /> ime reserves the right to update this agreement as
                  needed. Users are encouraged to review updates regularly to
                  remain informed.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default Agreement;
